import { FC, ReactNode } from 'react';
import { createUseStyles } from 'react-jss';
import { Box } from '@mui/material';
import Text from '../../text';

interface Props {
  label: string;
  propVal: ReactNode;
}

const useStyles = createUseStyles({
  propVal: {
    width: '100%',
  },
});

const ReadonlyPair: FC<Props> = ({ label, propVal }) => {
  const styles = useStyles();
  return (
    <>
      <Box mb={1}>
        <Text bold>{label}</Text>
      </Box>
      <Text color="grey" className={styles.propVal}>
        {propVal}
      </Text>
    </>
  );
};

export default ReadonlyPair;
